export default __webpack_public_path__ + "static/hero-bg-left-ed77e12352068afe0f6308390a9281fb.png";